import close from "../images/close.svg";
import backarrow from "../images/backarrow.svg";
import { useState } from "react";
import { ShowAlert } from "../../../common/alert";

const CreateTemplateComp = (props) => {
   const { onModalTapped, createNewTemplate = () => {}, setShowTemplate, loader } = props;
   const [title, setTitle] = useState("");
   const [description, setDescription] = useState("");
   const handleInputChange = (e) => {
      const { name, value } = e.target;
      if (name === "title") {
         setTitle(value);
      } else if (name === "description") {
         setDescription(value);
      }
   };
   const handleCreateTemplate = () => {
      if (title.length === 0 || description.length === 0) {
         ShowAlert("Please add Template Title and description", "error");
         return;
      } else {
         createNewTemplate({
            title: title,
            description: description,
         });
         setTitle("");
         setDescription("");
      }
   };

   return (
      <>
         {loader ? (
            <div
               style={{ width: "100%", height: "670px" }}
               class="d-flex justify-content-center align-items-center text-center"
            >
               <div class="d-flex justify-content-center">
                  <div
                     style={{ width: "8rem", height: "8rem" }}
                     className="spinner-border  loader-color text-center"
                  ></div>
               </div>
            </div>
         ) : (
            <>
               <div className="d-flex justify-content-center align-items-center">
                  <img
                     onClick={() => {
                        setShowTemplate(false);
                     }}
                     src={backarrow}
                     alt=""
                     className="back-arrow"
                  />
                  <div className="create-temp-text">New Clinical Note Templates</div>
                  <img onClick={onModalTapped} src={close} alt="close" className="close-poppup" />
               </div>
               <div className="border-bottom border"></div>
               <div className="temp-padding">
                  <div className="paragraph-text">
                     Create a new category for you clinical notes section. In your settings you can customize which
                     notes automate when you create custom content.
                  </div>
                  <input
                     name="title"
                     value={title}
                     onChange={handleInputChange}
                     placeholder="Note Title"
                     className={`  w-100 ${title.length === 0 ? "note-title-des-text" : "note-title-input-text"}`}
                  />
                  <textarea
                     rows="16"
                     cols="45"
                     name="description"
                     value={description}
                     onChange={handleInputChange}
                     placeholder="Note Description"
                     className={`textarea-margin ${
                        description.length === 0 ? "note-title-des-text" : "note-title-input-text"
                     }`}
                  ></textarea>
               </div>
               <div className="border-bottom border"></div>
               <div className="flex-center temp-create-padding">
                  <button onClick={handleCreateTemplate} className="temp-button-container flex-center">
                     <div className="note-category-text">Create Note Template</div>
                  </button>
               </div>
            </>
         )}
      </>
   );
};

export default CreateTemplateComp;
